import React from "react";
import underConst from "../../assets/const.png";
import { RegisterContainer, RegisterImage } from "./Register.style";

const Register = () => {
  return (
    <RegisterContainer>
      <RegisterImage src={underConst} alt="" />
    </RegisterContainer>
  );
};

export default Register;
